import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type ResultsHeaterProps } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";

export interface CPQProductConfigurationAttributeDTO {
  code: string;
  unit: string;
  value: string;
}

export interface HeaterSelectionRequestDTO {
  code: string;
  attributes: CPQProductConfigurationAttributeDTO[];
}

export interface HeaterSelectionResponseDTO {
  results?: ResultsHeaterProps[] | null;
}

export async function getHeaterSelection(data: HeaterSelectionRequestDTO): Promise<ResultsHeaterProps[]> {
  const response = await occFetch(occUrl("/heater-selection-assistant/submit"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  return ((await response.json()) as HeaterSelectionResponseDTO).results ?? [];
}
